/**
 * Memory verse reminder frequency options
 */
export var MemoryVerseFrequency;
(function (MemoryVerseFrequency) {
    MemoryVerseFrequency[MemoryVerseFrequency["FIVESECS"] = 5000] = "FIVESECS";
    MemoryVerseFrequency[MemoryVerseFrequency["HOURLY"] = 3600000] = "HOURLY";
    MemoryVerseFrequency[MemoryVerseFrequency["FEW_HOURS"] = 14400000] = "FEW_HOURS";
    MemoryVerseFrequency[MemoryVerseFrequency["DAILY"] = 345600000] = "DAILY";
    MemoryVerseFrequency[MemoryVerseFrequency["APP_LOAD"] = -1] = "APP_LOAD";
})(MemoryVerseFrequency || (MemoryVerseFrequency = {}));
//# sourceMappingURL=memory-verse-frequency.js.map